// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CameraTwoToneSvg from "@ant-design/icons-svg/es/asn/CameraTwoTone";
import AntdIcon from '../components/AntdIcon';

var CameraTwoTone = function CameraTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CameraTwoToneSvg
  }));
};

CameraTwoTone.displayName = 'CameraTwoTone';
export default React.forwardRef(CameraTwoTone);